export default __webpack_public_path__ + "static/media/angle-up-light.b0beab3f.svg";